// src/data/faqs.js
export const faqs = [
  {
    q: "Where is the meeting point?",
    a: "Default: Konbayan Espresso & Farm. For the Coffee Tour, hotel pickup (Senaru/Bayan) may be available.",
  },
  {
    q: "What should I bring?",
    a: "Comfortable clothes, sunscreen, extra water (optional), and safe shoes. For cycling: expect light sweating.",
  },
  {
    q: "How does payment work?",
    a: "Cycling: cash (usually). Coffee: cash IDR or PayPal (USD).",
  },
  {
    q: "Can we book a private tour?",
    a: "Yes. Send a message on the Contact page for private or group requests.",
  },
  {
    q: "What if it rains?",
    a: "Cycling can be rescheduled. Coffee tours usually run (more indoor activities).",
  },
  {
    q: "Is it beginner-friendly?",
    a: "Yes. Cycling pace is adjusted, and the coffee tour is friendly for everyone.",
  },
];
